import { useLinked } from "@type-r/react"
import { Column, Flex, Input } from "lqx-react"
import React from "react"
import { Criterian } from "../../../api/assetFilterCriteria"
import { Row } from "../../../components/item-card-styles"
import { StyledFormLabel } from "../../../components/number-input"

export const FilterCriteriaSectionMapper = ({ criterian, disabled }: { criterian: Criterian, disabled: boolean }) => {
    const $searchValue = useLinked(criterian.searchValue).onChange(value => criterian.searchValue = value);
    return (
        <Row>
            <Flex row>
                <Column>
                    <StyledFormLabel>{criterian.assetType.name} *</StyledFormLabel>
                </Column>
                <Column>
                    <Input disabled={disabled} data-qa-id={`${criterian.assetType.name}`} $value={$searchValue} />
                </Column>
            </Flex>
        </Row>
    );
}